import {useEffect, useState} from 'react';

/**
 * @returns true if the page is being rendered within an iframe.  Otherwise false.
 */
function useIsInIframe() {
  const [isInIframe, setIsInIframe] = useState(true);
  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch (e) {
      return setIsInIframe(true);
    }
  }, []);
  return isInIframe;
}
export default useIsInIframe;
